var template = require('./../templates/offline_chat.html');
var widgetHtml = template();
var $zopim;
var livechat;

if (typeof(window.$zopim) !== 'undefined') {
  $zopim = window.$zopim;
  // Must run as callback to $zopim to ensure livechat is loaded first
  $zopim(main);
}

function main() {
  livechat = (new Function('return window.$zopim.livechat;'))();
  createOfflineWidget(widgetHtml);

  var offlineWidget = document.getElementsByClassName('sc-offline-chat')[0];

  for(var i = 0; i < offlineWidget.children.length; i++) {
    var child = offlineWidget.children[i];

    if (child.className.indexOf('js-toggle-visibility') !== -1) {
      child.onclick = toggleOfflineWidget;
    }
  }

  livechat.setOnConnected(livechatConnectedListener);
  livechat.setOnStatus(livechatStatusListener);
}

function livechatConnectedListener() {
  var status;

  livechat.setOnStatus(function(s) {
    status = s;
  });

  livechatStatusListener(status);
}

function livechatStatusListener(status) {
  var offlineWidget = document.getElementsByClassName('sc-offline-chat')[0];

  switch(status) {
    case 'offline':
      if (!livechat.isChatting()) {
        livechat.hideAll();
        showOfflineWidget(offlineWidget);
      }
      else {
        livechat.window.show();
        hideOfflineWidget(offlineWidget);
      }
      break;
    case 'online':
      if (livechat.isChatting()) {
        livechat.window.show();
        hideOfflineWidget(offlineWidget);
      }
      else {
        livechat.window.hide();
        hideOfflineWidget(offlineWidget);
      }      
      break;
    case 'away':
      break;
  }
}

function hideOfflineWidget(offlineWidget) {
  offlineWidget.className += ' is-hidden';
}

function showOfflineWidget(offlineWidget) {
  offlineWidget.className = offlineWidget.className.replace(new RegExp(' ?is-hidden'), '');
}

function closeOfflineWidget(offlineWidget) {
  offlineWidget.className += ' is-closed';
  offlineWidget.className = offlineWidget.className.replace(new RegExp(' ?is-open'), '');
}

function openOfflineWidget(offlineWidget) {
  offlineWidget.className += ' is-open';
  offlineWidget.className = offlineWidget.className.replace(new RegExp(' ?is-closed'), '');
}

function toggleOfflineWidget(event) {
  var offlineWidget = document.getElementsByClassName('sc-offline-chat')[0];

  if (offlineWidget.className.indexOf('is-closed') === -1) {
   closeOfflineWidget(offlineWidget);
  }
  else if (offlineWidget.className.indexOf('is-open') === -1) {
    openOfflineWidget(offlineWidget);
  }
}

function createOfflineWidget(html) {
  document.body.insertAdjacentHTML('beforeend', html);
}



//////////////////
// WEBPACK FOOTER
// /Users/enummela/Dev/sites/safe-com-git/app/assets/js/external/offline_chat_widget.js
// module id = 20
// module chunks = 3